<template>
    <div>
    <v-select
            v-model="variableX"
            :items="selectItems"
            :label="label"
            :item-text="(item) => item.equipment_name + ' — ' + item.sensor_name"
            item-value="sensor_name"
            return-object
    ></v-select>
</div>
</template>

<script>
  export default {
    props: {
      label: {type: String, default: "Point"},
      equipment: {type: String},
      value: {type: Object, default: null}
    },
    data () {
      return {
        variableX: null
      }
    },
    mounted () {
      if (!!this.value) {
        if (this.variableX !== this.value){
          this.variableX = this.value
        }
      }
    },
    watch: {
      value () {
        if (this.variableX !== this.value){
          this.variableX = this.value
        }
      },
      variableX (newVariable) {
        this.$emit('input', newVariable)
      },
      selectItems () {
        //this.variableX = null
      },
      equipment (oldEquip, newEquip) {
        if(!!oldEquip){
          this.variableX = {
            sensor_name: this.variableX.sensor_name,
            equipment_name: this.equipment,
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name
          }
        }
      }
    },
    computed: {
      selectItems () {
      let output = []
      let id = 1
      // map format to v-treeview required format
      if (!this.$store.state.pointsListStore.pointsList) return [{id: 1, name: 'loading'}]
      for (let i in this.$store.state.pointsListStore.pointsList.sensors){
        if (i===this.equipment) {
          let children = []
          id++
          for (let j in this.$store.state.pointsListStore.pointsList.sensors[i]) {
            children.push({
              sensor_name: this.$store.state.pointsListStore.pointsList.sensors[i][j],
              equipment_name: i,
              facility_name: this.$store.state.pointsListStore.pointsList.facility_name
              })
              id++
          }
          output.push(...children)
        }
      }
      output.sort((a, b) => (a.equipment_name+a.sensor_name > b.equipment_name+b.sensor_name) ? 1 : -1)
      return output
    }
    },
    name: 'VariableSelector'
  }
</script>

<style scoped>

</style>
